
import DashboardAgents from "../molecules/DashboardAgents";

function HomeAgents() {
  return (
    <>
      <DashboardAgents/>
    </>
  );
}

export default HomeAgents;